import { globalBookingMessages } from '../messages'
import { createRequiredValidator } from '.'

export const defaultRequiredValidator = createRequiredValidator(
  globalBookingMessages.errors.required
)
